import { People1Icon, PlusIcon, XIcon } from "@skbkontur/icons";
import * as React from "react";

import cn from "./RequisitesSelect.less";
import { RequisitesSetEntry } from "./RequisitesSet";

interface RequisitesSelectProps {
    items: RequisitesSetEntry[];
    onSelect: (item: RequisitesSetEntry) => void;
    onRemove: (item: RequisitesSetEntry) => void;
    onCreateNew: () => void;
}

export function RequisitesSelect(props: RequisitesSelectProps): JSX.Element {
    return (
        <>
            <div className={cn("create-new-item")} onClick={props.onCreateNew}>
                <PlusIcon /> Добавить новый набор
            </div>
            {props.items.map(item => (
                <div
                    key={item.name}
                    className={cn("item")}
                    onClick={() => {
                        props.onSelect(item);
                    }}>
                    <span className={cn("item-name")}>
                        <People1Icon /> {item.name}
                    </span>
                    <span
                        className={cn("remove-button")}
                        onClick={e => {
                            e.stopPropagation();
                            props.onRemove(item);
                        }}>
                        <XIcon />
                    </span>
                    <div className={cn("short-info")}>
                        {objectToPairsRecursive(item.value.content).map(x => (
                            <span className={cn("short-info-item")} key={x[0]}>
                                <span className={cn("name")}>{x[0]}</span>
                                <span className={cn("value")}>{x[1]}</span>
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </>
    );
}

type FlatObjectEntry = [string, string | boolean | number];

function objectToPairsRecursive(object: {}): FlatObjectEntry[] {
    const result: FlatObjectEntry[] = [];
    for (const key of Object.keys(object)) {
        // @ts-ignore
        const value = object[key];
        if (value == undefined) {
            continue;
        }
        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
            result.push([key, value]);
        }
        if (Array.isArray(value)) {
            const flat = value
                .map(objectToPairsRecursive)
                .map((pairs, index) => pairs.map(([k, v]): FlatObjectEntry => [index.toString() + "." + k, v]))
                .flat(1);
            result.push(...flat);
        }
        if (typeof value === "object") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            result.push(...objectToPairsRecursive(value).map(([k, v]): FlatObjectEntry => [key + "." + k, v]));
        }
    }
    return result;
}
